/**
 * Mail IKart Normalize Utility
 *
 * DB'de pure IKart yapısında saklanan mail dökümanlarını
 * template-friendly flat alanlara dönüştürür.
 */

import type { IMailMesaj, IMailEk } from '../interfaces/mail.interface';

/**
 * IKart mail dökümanını flat alanlara normalize eder.
 * Template'ler flat alan isimleri kullanır (kimden, konu, ekler, vb.).
 *
 * DB (IKart)              → Template (flat)
 * veri.kimden             → kimden
 * veri.kime               → kime
 * veri.konu               → konu
 * icerikler[0].html       → icerikHtml
 * icerikler[0].aciklama   → icerik
 * dosyalar[].ismi         → ekler[].dosyaAdi
 */
export function normalizeMailKart(m: any): IMailMesaj {
  if (!m) return m;
  const v = m.veri;
  if (!v) return m;

  const ic = m.icerikler?.[0];

  return {
    ...m,
    kimden: v.kimden,
    kime: v.kime,
    konu: v.konu,
    klasor: v.klasor,
    okundu: v.okundu,
    okunduBy: v.okunduBy,
    hesapId: v.hesapId,
    firmaId: v.firmaId,
    messageId: v.messageId,
    uid: v.uid,
    inReplyTo: v.inReplyTo,
    icerik: ic?.aciklama ?? '',
    icerikHtml: ic?.html ?? '',
    ekler: (m.dosyalar ?? []).map((d: any): IMailEk => ({
      dosyaAdi: d.ismi ?? '',
      boyut: d.boyut ?? 0,
      tur: d.tipi ?? '',
      dosyaId: d.rota ?? '',
      url: d.url,
    })),
  };
}
